import { type Location, useNavigate } from 'react-router-dom';
import { removeSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';

import { removeSession } from '@/store/global/session/selectors';

export function useRedirectToLogin() {
  return (currentLocation?: Location) => {
    removeSession();
    removeSonataSession();
    const next =
      currentLocation && currentLocation.pathname !== '/login'
        ? `${currentLocation.pathname}${currentLocation.search}${currentLocation.hash}`
        : undefined;
    const target = next ? `/login?next=${encodeURIComponent(next)}` : '/login';
    window.location.replace(target);
  };
}

export function useRedirectToMain() {
  const navigate = useNavigate();
  return (currentLocation?: Location) => {
    navigate('/campaigns', { state: { redirectUrl: currentLocation?.pathname } });
    window.location.reload();
  };
}

export function useRedirectToRoot() {
  const navigate = useNavigate();
  return () => {
    navigate('/');
  };
}
